import { $lt as __lt, createExpressionOperator } from "../../_predicates";
const $lt = createExpressionOperator(__lt);
export {
  $lt
};
